export default __webpack_public_path__ + "static/media/MachineCodes_desktop.a804f418.png";